var map = {
	"./animals.png": 35564,
	"./arts.png": 23650,
	"./community.png": 34735,
	"./culture.png": 21177,
	"./education.png": 35346,
	"./environment.png": 45387,
	"./find-a-cure.png": 959,
	"./health-n-wellness.png": 75496,
	"./human-n-civil-rights.png": 54886,
	"./human-services.png": 72356,
	"./international-religion.png": 12172,
	"./other.png": 85514,
	"./public-policy.png": 59892,
	"./research.png": 68362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74579;